<template>
  <table>
    <thead>
      <tr class="level-one-header">
        <th colspan="8">FT-IR Analysis (ASTM D7418)</th>
        <th colspan="1">ASTM 6304</th>
        <th colspan="1">ASTM D2896</th>
        <th colspan="1">ASTM D4739</th>
        <th colspan="1">ASTM D664</th>
        <th colspan="2">Viscosity (cSt) (ASTM D445)</th>
        <th colspan="3">Advanced Properties</th>
      </tr>
      <tr class="level-two-header">
        <th class="sample-number">Lab ID</th>
        <th>Oxidation (A/cm)</th>
        <th>Nitration (A/cm)</th>
        <th>Sulfation (A/cm)</th>
        <th>Glycol (P/N)</th>
        <th>Fuel (%)</th>
        <th>Soot (%)</th>
        <th>Water (%)</th>
        <th>Water (ppm)</th>
        <th>BN (mg KOH/g)</th>
        <th>BN (mg KOH/g)</th>
        <th>AN (mg KOH/g)</th>
        <th>100c</th>
        <th>40c</th>
        <th>Sulfur (ppm)</th>
        <th>Chlorine (ppm)</th>
        <th>MPC</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(sample, index) in sampleData.oilSamples" :key="`Secondary Table Sample ${index}`">
        <td>{{ sample.sampleNumber }}</td>
        <td :class="`severity-id-${sample.newOxidationSeverity}`">{{ roundVal(0, true, sample.newOxidation) }}</td>
        <td :class="`severity-id-${sample.newNitrationSeverity}`">{{ roundVal(0, true, sample.newNitration) }}</td>
        <td :class="`severity-id-${sample.newSulfationSeverity}`">{{ roundVal(0, true, sample.newSulfation) }}</td>
        <td :class="`severity-id-${sample.antifreezeSeverity}`">
          {{ sample.antifreeze ? 'Yes' : 'No' }}
        </td>
        <td :class="`severity-id-${sample.fuelDilutionSeverity}`">
          {{ roundVal(1, false, sample.fuelDilution) }}
        </td>
        <td :class="`severity-id-${sample.sootIndexSeverity}`">{{ roundVal(2, true, sample.sootIndex) }}</td>
        <td :class="`severity-id-${sample.waterPercent || sample.waterPercent === 0 ? sample.waterSeverity : ''}`">
          {{ roundVal(2, true, sample.waterPercent) }}
        </td>
        <td :class="`severity-id-${sample.waterPpm ? sample.waterSeverity : ''}`">{{ sample.waterPpm }}</td>
        <td :class="`severity-id-${sample.bnSeverity}`">{{ roundVal(2, true, sample.bn) }}</td>
        <td :class="`severity-id-${sample.tbnSeverity}`">{{ roundVal(2, true, sample.tbn) }}</td>
        <td :class="`severity-id-${sample.tanSeverity}`">{{ roundVal(2, true, sample.tan) }}</td>
        <td :class="`severity-id-${sample.viscosity100cSeverity}`">
          {{ roundVal(1, false, sample.viscosity100c) }}
        </td>
        <td :class="`severity-id-${sample.viscosity40cSeverity}`">
          {{ roundVal(1, false, sample.viscosity40c) }}
        </td>
        <td :class="`severity-id-${sample.sulphurSeverity}`">
          {{ roundVal(0, false, sample.sulphur) }}
        </td>
        <td :class="`severity-id-${sample.chlorineSeverity}`">
          {{ roundVal(0, false, sample.chlorine) }}
        </td>
        <td :class="`severity-id-${sample.mpcSeverity}`">
          {{ roundVal(1, false, sample.mpc) }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import RoundingMixin from '../../shared/RoundingMixin';
export default {
  name: 'OilSampleReportAnalysis',
  props: {
    sampleData: {
      type: Object,
      required: true
    }
  },
  mixins: [RoundingMixin]
};
</script>
